import { useState, useEffect } from 'react'
import * as HELPER from "../../../config/helper";
import InsuranceService from 'services/InsuranceService';
import { toast } from 'react-toastify';
import FullPageLoader from '@src/common/FullPageLoader';
import { useNavigate } from 'react-router-dom';
import { APP_TYPE_RENEWAL, APP_TYPE_STANDALONE, APP_TYPE_WITH_UCF, INS_TYPE_COMPREHENSIVE, INS_TYPE_CTPL, LEAD_TYPE_WEB_APP, REGEX_DECIMAL_VALIDATION, WITH_RULE_ENGINE, WITHOUT_RULE_ENGINE,APP_AGENCY, ROLE_IDS, VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL, STATUS_SUCCESS } from '@src/config/constant';
import { useSelector, useDispatch } from 'react-redux';
import { saveInsurance } from '@src/store/slices/insurance';
import { COUNTRY_CODE } from '@src/config/constant';
import { useLanguage } from '@src/context/LanguageContext';
import AgencyService from '@src/services/AgencyService';
import { DISCOUNT_TYPE, INSURANCE_EXISTS, QUOTATION_SHARE_TYPE, TENURE, WHATSAPP_WEB_URL } from '@src/config/id/constant';
import CommonService from '@src/services/CommonService';
import ReactSelect from '@common/ReactSelect';
import _ from 'lodash';
import { Tooltip as TooltipLite } from 'react-tooltip';
import moment from 'moment';





interface MainProps {
    params: any,
    setExtraField: any,
    applicationType: any,
    extraField: any,
    setParentPage: Function,
    backFunc: Function,
    nextFunc: Function,
    apptype: any,
    activeLoanID: any,
    masterData:any,
    setLoading:any,
    sectionList:any
}
const QuotesListID = (props: MainProps) => {

    const isCountryId = COUNTRY_CODE ==='id' ? true : false;
    
    const [partnerList, setPatnerList] = useState<Array<Object>>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [showField, setField] = useState<any>({}); 
    const [inputField, setInputField] = useState<any>({ partner_id: 0, add_on_rate: 2 })
    const [insurerData, setInsurerData] = useState<any>([])
    const [tabActive, setActiveTab] = useState<string>('first')
    const insuranceState = useSelector((state: any) => state.insurance);
    const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const [insurerIds,setInsurerIds] = useState<any>([]);
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    const {translations,language} = useLanguage();
    const [discountType, setDiscountType] = useState<any>('');
    const [customerDiscount, setCustomerDiscount] = useState('');
    const [discountError, setDiscountError] = useState('');
    const [tooltip, setTooltip] = useState<any>({});

    const isLangId = language === 'id'?true:false;

    const getPrimaryInsuranceType = (insuranceTypeValue: any) => {
        if (Array.isArray(insuranceTypeValue)) {
            return Number(insuranceTypeValue?.[0])
        }

        return Number(insuranceTypeValue)
    }

    const currentInsuranceType = getPrimaryInsuranceType(props?.params?.insurance_type);

    useEffect(() => {
        fetchPartner()
        if (Object.keys(props.extraField).length) {
            setInputField(props.extraField)
        }
        // eslint-disable-next-line
    }, [])

    const fetchPartner = async (customerDiscount: any = "", disType: any = "") => {
        let reqParam = props.params;
        
        let params: any = {
            vehicle_usage: reqParam.vehicle_usage,
            insurance_type: reqParam.insurance_type,
            rule_engine: props.applicationType,
            total_fmv: reqParam.total_fmv,
            apptype: props.apptype,
            addon_detail: reqParam.addon_detail,
            vehicle_type: reqParam.vehicle_type,
            insurance_starting_date: moment(reqParam.insurance_start_date).format('YYYY-MM-DD')
        }
        if (getPrimaryInsuranceType(params.insurance_type) === INS_TYPE_CTPL) {
            params['tenure'] = reqParam.tenure
            params['make_year'] = reqParam.make_year
        }else if(getPrimaryInsuranceType(params.insurance_type) === INS_TYPE_COMPREHENSIVE){
            params['make_year'] = reqParam.make_year
        }
        
        let engineCapacity = reqParam.engine_capacity
        if(engineCapacity) {
            params['engine_capacity'] = reqParam.engine_capacity
        }
        
        //add proposed fmv in request params
        if(props.apptype === APP_TYPE_WITH_UCF && reqParam?.proposed_fmv) params['proposed_fmv'] =  reqParam.proposed_fmv

        //if add on rate/referrer mark up is edited then use edited add_on_rate for api call
        if(props?.extraField?.add_on_rate) params['add_on_rate'] = props.extraField.add_on_rate
        if(props?.extraField?.referrer_mark_up) params['referrer_mark_up'] = props.extraField.referrer_mark_up
        
        if(isCountryId){
            let  plate_area_type =  props?.sectionList?.[0]?.blocks?.[0]?.fields?.find((field: any) => field.name === 'plate_area')?.value?.plate_area_type;
            let  bstk_age =  props?.sectionList?.[0]?.blocks?.[0]?.fields?.find((field: any) => field.name === 'bstk_age')?.value;
            
            delete params.apptype
            // delete params.rule_engine
            delete params.engine_capacity
            params.sort_by ='RC'
            params.customer_discount_per = (discountType === DISCOUNT_TYPE.DISCOUNT)? Number(customerDiscount): props?.extraField?.customer_discount_per ||  0
            params.customer_discount = (discountType === DISCOUNT_TYPE.AMOUNT)? Number(customerDiscount): props?.extraField?.customer_discount || 0
            params.car_fmv = reqParam.car_fmv
            params.make = reqParam.make
            params.vehicle_condition = reqParam.vehicle_condition
            params.plate_area_type = String(plate_area_type)

        
            if(disType !=="" && disType!== props?.extraField?.discountType){
                params.customer_discount_per =  0
                params.customer_discount =  0
            }
            if(+discountType===+DISCOUNT_TYPE.DISCOUNT){
                params.customer_discount_per = Number(customerDiscount)
                params.customer_discount =  0
            }
            if(+discountType===+DISCOUNT_TYPE.AMOUNT){
                params.customer_discount = Number(customerDiscount)
                params.customer_discount_per =  0
            }
            if(bstk_age) params.bstk_age = bstk_age;
            const multi_year = params.insurance_type?.map((row:any)=>{
                return {
                    insurance_type: row
                }
            })
            params.multi_year = multi_year
            delete  params.insurance_type
            params.tenure = reqParam.tenure


        }
       
        setLoading(true);
        let result = isCountryId ? await InsuranceService.getAddonDetailsID(params) : await InsuranceService.getPartnerList(params)
        if(isCountryId){
            setInsurerData(result?.data?.data)
            if(tabActive==='first'){
                result.data.data = result?.data?.data?.quotation || []
            }else{
                result.data.data = result?.data?.data?.other || []
            }
        }
        
        setLoading(false);
        if (result?.data?.data) {
            if ([APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(props.apptype)) checkDiscount(result.data.data)
            setPatnerList(result.data.data);
            
        } else {
            toast.error(result?.data?.errors)
            props.setParentPage(1)
            navigate('/create-insurance-policy?step=insurance_form');
        }
    }

    const getAddonDetail = async (partner_id: number, ob: object) => {

        setLoading(true)
        let reqParam = props.params;
        let loanData = insuranceState?.activeLoanID
        let params: any = {
            partner_id: partner_id,
            vehicle_usage: reqParam.vehicle_usage,
            insurance_type: reqParam.insurance_type,
            rule_engine: props.applicationType,
            total_fmv: reqParam.total_fmv,
            lead_type: props.apptype === APP_TYPE_WITH_UCF ? loanData?.lead_type : LEAD_TYPE_WEB_APP,
            role_id: (props.apptype === APP_TYPE_WITH_UCF && loanData?.lead_type === 1) ? ROLE_IDS['so_id'] : props.apptype !== APP_TYPE_WITH_UCF ? 3 : 0,
            apptype: props.apptype,
            addon_detail: reqParam.addon_detail,
            vehicle_type: reqParam.vehicle_type,
            mfg_year: reqParam.make_year
        }
        if (getPrimaryInsuranceType(params.insurance_type) === INS_TYPE_CTPL) {
            params['tenure'] = reqParam.tenure
        }
        if(insuranceState.application_type_id === APP_AGENCY){
            params["agency_id"]=insuranceState?.agency_id  
        }

        if ([VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(params.vehicle_type)) {
 
            params['engine_capacity'] = reqParam.engine_capacity
        }

        //handle proposed fmv
        if (props.apptype === APP_TYPE_WITH_UCF) {
            params.proposed_fmv = reqParam.proposed_fmv || 0
        }
        
        params = Object.assign(params, ob);
        let result = await InsuranceService.getAddonDetails(params)
        setLoading(false)
        if (result?.data?.data && Object.keys(result?.data?.data)?.length) {
            let partnerUpdated = partnerList.map((ob: any) => {
                return (+ob.id === +partner_id) ? Object.assign(ob, result.data.data) : ob
            })
            setPatnerList(partnerUpdated)
            let keys = ['referrer_mark_up', 'net_premium', 'discount']
            let checkIfKeyExists = keys.some((ele: any) => Object.keys(ob).includes(ele))
            if(checkIfKeyExists) {
                //update input fields after successful api call 
                setInputField(ob)
                props.setExtraField(ob)
            }
        } else {
            toast.error(result.data.message);
        }
    }

    const changeHandler = (partner_id: number, add_on_rate: number, slug: string) => {
        //find netpremium
        let grossPremium: any = partnerList.find((partner: any) => partner.id === partner_id)
        grossPremium = grossPremium ? grossPremium.gross_premium : 0

        setInputField({ partner_id, add_on_rate })
        props.setExtraField({ partner_id, add_on_rate, partner_slug: slug }) 

        //update net premium in state
        dispatch(saveInsurance({ 
            ...insuranceState.createInsurance, 
            gross_premium: grossPremium,
        }));
    }   
    
  
    const changeHandlerId = (partner_id: number, insurer_id: number) => {
    
        let updatedInsurerIds = [...insurerIds];
        if(inputField?.share_insurer_ids &&  inputField?.share_insurer_ids ==='string'){
            updatedInsurerIds = [...updatedInsurerIds,Number(inputField?.share_insurer_ids)]
        }
       
        if (!updatedInsurerIds.includes(insurer_id)) {
            updatedInsurerIds.push(insurer_id);  
        }else{
            updatedInsurerIds.splice(updatedInsurerIds.indexOf(insurer_id), 1);
        }
        if(updatedInsurerIds.length > 1){
            setDisableSaveButton(true);
            props.setExtraField({ share_insurer_ids: updatedInsurerIds?.join(',')})
            setInputField({...inputField, partner_id, insurer_id,share_insurer_ids: updatedInsurerIds?.join(',')})

        }else if (+updatedInsurerIds?.length == 1){
            setDisableSaveButton(false);
            const partner:any = partnerList?.find((row:any)=>row.insurer_id == updatedInsurerIds?.join(','))
            props.setExtraField({ partner_id:partner?.partner_id, insurer_id:partner?.insurer_id,share_insurer_ids: updatedInsurerIds?.join(',')}) 
            setInputField({...inputField, partner_id:partner?.partner_id, insurer_id:partner?.insurer_id,share_insurer_ids: updatedInsurerIds?.join(',')})
        }else{
            setDisableSaveButton(true);
            setInputField({...inputField,share_insurer_ids: updatedInsurerIds?.join(',')})

        }
        setInsurerIds(updatedInsurerIds);
       
        //find netpremium
        let grossPremium: any = partnerList.find((partner: any) => partner.insurer_id === insurer_id)
        grossPremium = grossPremium ? grossPremium.gross_premium : 0


        //update net premium in state
        dispatch(saveInsurance({ 
            ...insuranceState.createInsurance, 
            gross_premium: grossPremium,
        }));
    }
    const shareQuotes = async () => {
        const selectedInsurerIds = (props?.extraField?.share_insurer_ids || inputField?.share_insurer_ids || '').split(',').filter((id: string) => id?.trim());

        if(!selectedInsurerIds.length) return toast.error(translations?.CREATE_APPLICATION?.PLEASE_SELECT_INSURER);
        if(selectedInsurerIds.length > 3) return toast.error("You can share up to 3 quotations only");
        props.setLoading(true)
        const insurance_starting_date = props?.params?.insurance_start_date;
        const customer_name = props?.params?.name || 'NA';
        delete props?.params?.name
        delete props?.params?.insurance_start_date
        let  plate_area_type =  props?.sectionList?.[0]?.blocks?.[0]?.fields?.find((field: any) => field.name === 'plate_area')?.value?.plate_area_type;
             
        const reqParam:Record<string,any> = {
            share_insurer_ids:props?.extraField?.share_insurer_ids,
            addon_detail:props?.params?.addon_detail,
            user_id:props?.params?.user_id,
            role_id:props?.params?.role_id,
            vehicle_type:props?.params?.vehicle_type,
            make:props?.params?.make,
            make_name:props?.params?.make_name,
            model:props?.params?.model,
            model_name:props?.params?.model_name,
            version:props?.params?.version,
            version_name:props?.params?.version_name,
            make_year:props?.params?.make_year,
            car_fmv:props?.params?.car_fmv,
            total_fmv:props?.params?.total_fmv,
            vehicle_usage:props?.params?.vehicle_usage,
            insurance_type:props?.params?.insurance_type,
            policy_holder:props?.params?.policy_holder,
            vehicle_condition:props?.params?.vehicle_condition,
            is_shared:QUOTATION_SHARE_TYPE.QUOTATION_SHARE,
            customer_name:customer_name,
            insurance_starting_date,
            tenure:props?.params.tenure,
            is_acc: (props?.params?.acc_description || props?.params?.acc_price)? 1: 2,
            customer_discount: +discountType ===  +DISCOUNT_TYPE.AMOUNT ? Number(customerDiscount): 0,
            customer_discount_per: +discountType === +DISCOUNT_TYPE.DISCOUNT ? Number(customerDiscount): 0,
            plate_area:props?.params?.plate_area,
            plate_area_type,
            acc_price:props?.params?.acc_price,
            origin: 'web',
            rule_engine: props?.applicationType,
            insurance_exists: props?.params?.insurance_exists || INSURANCE_EXISTS.NO,
            parent_model_id: props?.params?.parent_model_id,
            parent_model_name: props?.params?.parent_model_name,
        
        }
        const multi_year = reqParam.insurance_type?.map((row:any)=>{
            return {
                insurance_type: row
            }
        })
        reqParam.multi_year = multi_year
        delete  reqParam.insurance_type
        reqParam.insurance_ending_date = props?.params?.insurance_ending_date
        reqParam.vehicle_category = props?.params?.vehicle_category
        if(props?.extraField?.share_insurer_ids?.split(',')?.length === 1){
            reqParam.insurer_id = +props?.extraField?.insurer_id
        }

        
        const result = await AgencyService.createAgencyLead(reqParam);
        if(result?.data?.status===STATUS_SUCCESS){
            let path = result?.data?.data?.pdfPath;
            if (path) {
                path = await CommonService.getShortFileUrl({url:path})
                path = path?.data?.data
            }
            if (!path || typeof path !== 'string') {
                toast.error("Quotation PDF is not ready yet. Please try sharing again in a moment.");
            } else {
                const message = `${translations?.CREATE_APPLICATION?.DOC_SHARE_MSG} ${path}`;
                const url = WHATSAPP_WEB_URL + encodeURIComponent(message);
                window.open(url, '_blank', 'noreferrer');
            }
        }else{
            toast.error(result?.data?.message);
        }
        props.setLoading(false)
    }

    const setInputValue = (event: any, partner_id: number) => {
        let name = event?.target?.name
        let value = event.target.value;
        const regex = REGEX_DECIMAL_VALIDATION
        const allowDecimalFor = ['net_premium', 'referrer_mark_up', 'discount']
        const isDecimalEnable = allowDecimalFor.includes(name)

        if (!isDecimalEnable || ((isDecimalEnable && (regex.test(value))))) {
            //replace leading 0's
            if (value && isDecimalEnable) value = value.toString().replace(/^0+/, '')
            event.target.value = value

            if (isDecimalEnable) {
                let partner: any = partnerList?.find((e: any) => e.id === partner_id)

                let fmv = partner?.proposed_fmv || partner?.total_fmv
                //return if entered value is greator than total fmv
                if (fmv && +event.target.value >= fmv) return
            }

            let ob = { ...inputField, [event.target.name]: +value }

            //if netpremium is changed, update discount to 0
            if(props.apptype === APP_TYPE_STANDALONE && name === 'net_premium') {
                ob['discount'] = 0
            }

            //update input 
            if (!isDecimalEnable || (name === 'discount' && value.toString()?.length < 2 && value !== '')) {
                setInputField(ob)
                props.setExtraField(ob)
            }
            //update inputfield 
            //when name is not discount or if name is discount then it should be a double digit or 0
            if (name !== 'discount' || (name === 'discount' && (!value || value?.toString()?.length > 1))) {
                getAddonDetail(partner_id, ob);
            }
        }
    }

    const handleBtnClick = (type: string, itemOb: any) => {
        let rate = type === 'add' ? inputField.add_on_rate + itemOb.basic_rate_incement : inputField.add_on_rate - itemOb.basic_rate_incement; 

        let value = +parseFloat(rate).toFixed(2); 

        if (+value < itemOb.basic_rate_min) {
            toast.error("Add on rate should not be less than "+itemOb.basic_rate_min)
        }else  if (+value > itemOb.basic_rate_max) {
            toast.error("Add on rate should not be greater than "+itemOb.basic_rate_max)
        }else {
            getAddonDetail(inputField.partner_id, { add_on_rate: value });
            setInputField((prev: any) => {
                let obj = { ...prev }
                if (prev['discount'] && prev['discount'] > 0) obj['discount'] = 0 //on rate increment/decrement reset discount
                return { ...obj, add_on_rate: value }
            })
            let extraFs = { ...props.extraField, add_on_rate: value }
            if (extraFs['discount'] && extraFs['discount'] > 0) extraFs['discount'] = 0 //on rate increment/decrement reset discount
            props.setExtraField({ ...extraFs })
        }
    }

    /**
     * Checks if entered discount is valid, if not then resets it to 0
     * @param partners List of partners
     */
    const checkDiscount = (partners: any) => {
        let { gross_premium } = insuranceState.createInsurance
        let partner = partners.find((p: any) => p.id === props.extraField.partner_id)

        //if previous net premium and current net premium does not match, then reset discount
        if (partner && partner.gross_premium !== gross_premium) {
            setInputField((prev: any) => ({ ...prev, discount: 0 }))
            props.setExtraField({ ...props.extraField, discount: 0 })
            //update net premium in state
            dispatch(saveInsurance({ ...insuranceState.createInsurance, gross_premium: partner.gross_premium }));
        }
    }

    let actNature=props?.params?.addon_detail?.filter((el:any)=>el.id===6);

    const changeTab =(tabName:string)=>{
        if(tabName === 'first'){
            setPatnerList(insurerData.quotation);
        }else{
            setPatnerList(insurerData.other);
        }
        setActiveTab(tabName);
    }

    const optionList = [{ value: '1', label: translations?.CREATE_APPLICATION?.AMOUNT }, { value: '2', label: translations?.CREATE_APPLICATION?.DISCOUNT }]


    const handleDiscountTypeChange = (selectedOption: any) => {
        setDiscountType(selectedOption?.value || '');
        setInputField({ ...inputField, discountType: selectedOption?.value,customer_discount: '',customer_discount_per: '' });
        setDiscountError('');
        setCustomerDiscount('');
        fetchPartner("", selectedOption?.value);
    };

    // Handle customer discount input change
    const handleDiscountChange = (event: any, discountTypeValue:any = discountType) => {        
        let value = event.target.value;
        if (!discountTypeValue) {
            discountTypeValue = inputField?.discountType;
        }
        if (+discountTypeValue === DISCOUNT_TYPE.AMOUNT) {
            value = HELPER.removeCurrencyFormattingId(value);
        }
        let error:boolean = false;
        if (discountTypeValue == DISCOUNT_TYPE.DISCOUNT && parseFloat(value) > 25) {
            setDiscountError(translations?.CREATE_APPLICATION?.MAX_DISCOUNT_ERROR);
            error =true
        }else{
            setDiscountError('');

        }
        if(!discountTypeValue) discountTypeValue = inputField?.discountType
        setCustomerDiscount(value);
        const customerDiscount:any = discountTypeValue ==  DISCOUNT_TYPE.AMOUNT ? Number(value): 0
        const customerDiscountPer = discountTypeValue == DISCOUNT_TYPE.DISCOUNT ? Number(value): 0
        setInputField({ ...inputField, customer_discount: customerDiscount,customer_discount_per: customerDiscountPer,discountType: discountTypeValue,insurer_id: '',partner_id: '',share_insurer_ids: '' })
        props.setExtraField({ ...props.extraField, customer_discount: customerDiscount, customer_discount_per: customerDiscountPer,discountType: discountTypeValue,insurer_id: '',partner_id: '',share_insurer_ids: '' })
        setDisableSaveButton(false);
        setInsurerIds([])

        if (error===false && discountTypeValue) {
                debouncedFetchPartner(value);
        }
       
    };
    

    const debouncedFetchPartner =_.debounce((value) => {
        fetchPartner(value); 
    }, 1000)

    const handleTooltip = (key: string,action:string) => {
        const updated:any = {...tooltip};
        if(action === "close"){
         updated[key] = false;
        }else{
            for(let row in updated){
                updated[row] = false
            }
         updated[key] = true;
        }
        setTooltip(updated);
    };

    const getOrdinalLabel = (value: number) => {
        const mod100 = value % 100;
        if (mod100 >= 11 && mod100 <= 13) return `${value}th`;
        switch (value % 10) {
            case 1:
                return `${value}st`;
            case 2:
                return `${value}nd`;
            case 3:
                return `${value}rd`;
            default:
                return `${value}th`;
        }
    };

   const AddOnsDetailsBreakdown = ({ data }: { data: any[] }) => {
    if (!Array.isArray(data) || data.length === 0) return null;

    return (
        <>
            {data.map((row: any) => (
                <ul key={row.tenure} className="year-tenure-outer">
                    
                    {/* Header */}
                    <li className="multi-tenure-row">
                        {`${row.tenure_label || ""} - ${HELPER.formatDate(row.insurance_start_date,"dd MMM, yyyy")} - ${HELPER.formatDate(row.insurance_end_date,"dd MMM, yyyy")}`}
                    </li>

                    {/* Grid */}
                
                        {/* Basic Premium */}
                        <li>
                            <span className="text-gray-500">Basic Premium</span>
                            <label >
                                {HELPER.addCurrencyFormatting(row.basic_premium_amount)}
                            </label>
                        </li>

                        {/* Total Addon */}
                        
                        <li>
                            <span className="text-gray-500">Add Ons Premium</span>
                            <label >
                                {HELPER.addCurrencyFormatting(row.total_addon_amount)}
                            </label>
                        </li>

                        {/* Addon List */}
                        {(row?.addon_list || []).map((addon: any, idx: number) => (
                            // <div key={idx}>
                            <>
                                <li className="text-gray-500">
                                    <span>
                                    {addon.name || `Add On ${idx + 1}`}
                                    </span>
                                    <label>
                                         {HELPER.addCurrencyFormatting(addon.premium_amount)}
                                    </label>
                                </li>
                             
                                {/* Optional Note */}
                                {/* {addon.note && (
                                    <li style={{ fontSize: "10px", fontStyle: "italic" }}>
                                        {addon.note}
                                    </li>
                                )} */}
                                
                            {/* </div> */}
                            </>
                        ))}
                    
                </ul>
            ))}
        </>
    );
};

   
    
    return (
        <div className="loan-filed-sec">
            <FullPageLoader show={loading} />
            <div className="heading-dp-txt">
                <div className={isCountryId ?'loan-btn-heading-id':'loan-btn-heading'}>
                    {
                        !isCountryId && (
                            <span>Insurance Loan Quotes</span>
                        )
                    }
                    {
                        isCountryId && (
                            <div>
                                <button
                                    style={{
                                        minWidth: tabActive === "first"
                                            ? (isLangId ? "235px" : "170px")
                                            : (isLangId ? "200px" : "160px")
                                    }}
                                    className={tabActive === 'first' ? "btn-primary m-sm" : "btn-line"}
                                    onClick={() => changeTab('first')}>{translations?.CREATE_APPLICATION?.LOAN_QUOTATION}
                                </button>
                                <button
                                    style={{ minWidth: tabActive === "second" ? (isLangId ? "160px" : "170px") : (isLangId ? "140px" : "") }}
                                    className={tabActive === 'second' ? "btn-primary m-sm" : "btn-line"}
                                    onClick={() => changeTab('second')}>
                                    {translations?.CREATE_APPLICATION?.OTHER_QUOTATION}
                                </button>
                            </div>

                        )
                    }

                    <div>
                        {isCountryId && partnerList.length? (
                            <button className="btn-primary m-sm min-w-[132px]" style={{ minWidth: "132px" }} onClick={() => shareQuotes()}>
                                {translations?.CREATE_APPLICATION?.SHARE_QUOTATION}
                            </button>
                        ) : null}
                        <button className="btn-line m-sm-r" onClick={() => props.backFunc()}>{translations?.commonMsg?.back || 'Back'} </button>
                        <button className="btn-primary" onClick={() => props.nextFunc()} disabled={disableSaveButton}>{translations?.commonMsg?.["Save & Next"] || 'Save & Next'}</button>
                    </div>
                </div>
            </div>
                <div className='d-flex row m-md-b'>
                    <div className='col-md-3'>
                        <ReactSelect
                            options={optionList}
                            value={
                                inputField?.discountType ? optionList.find(option => option.value === inputField?.discountType):
                                optionList.find(option => option.value === discountType)
                            }
                            placeholder={translations?.CREATE_APPLICATION?.DISCOUNT_TYPE}
                            fieldKey=""
                            fieldSetClassName={"form-filed"}
                            handleChange={(e: any) => handleDiscountTypeChange(e)}
                        />
                    </div>
                    
                    <fieldset className='col-md-3'>
                    <div className='material'>
                            <input
                                type={'text'}
                                spellCheck={false}
                                placeholder=" "
                                value={
                                +inputField?.discountType === 2
                                    ? inputField?.customer_discount_per ?? ""
                                    : +inputField?.discountType === 1
                                    ? HELPER.addCurrencyFormatting(inputField?.customer_discount)
                                    : customerDiscount ?? ""
                                }
                                name={""}
                                className="form-input"
                                onChange={handleDiscountChange}
                                onKeyDown={(e) => HELPER.restrictInvalidNumberKeys(e)}
                                onWheel={(e) => e.currentTarget.blur()}
                            />
                            <label data-label={translations?.CREATE_APPLICATION?.CUSTOMER_DISCOUNT} className="form-label"></label>

                        
                        {discountError && (
                            <div className="error-txt">
                                {discountError}
                            </div>
                        )}
                    </div>
                        </fieldset>
                                  
                </div>
                <div className='qutation-count'>
                    <span>
                        {
                            tabActive==='first' && translations?.CREATE_APPLICATION?.QUOTATION_COUNT_MSG?.replace('{{count}}',`${partnerList.length}`)
                        }
                        {
                            tabActive==='second' && translations?.CREATE_APPLICATION?.OTHER_QUOTATION_COUNT_MSG?.replace('{{count}}',`${partnerList.length}`)
                        }
                    </span>
                </div>

            {
                partnerList.length ? partnerList.map((item: any, index) => {
                

                    return (<div className={index === 0 ? isCountryId ? 'financer-quote-data':`financer-quote-data p-t-70` : `financer-quote-data`} key={index}>


                        <div className="top-heading financer-lead-heding insurace-quote-heading" style={{marginTop: '10px'}}>
                            <h1>{isCountryId ? item.insurer_name : item.name}</h1>
                            <div className="custom-control custom-checkbox">
                                {
                                    isCountryId ?  <input 
                                    id={`partner_id${item.insurer_id}`} 
                                    type="checkbox" 
                                    className="custom-control-input" 
                                    name="partner_id"
                                     onChange={() => 
                                        changeHandlerId(item.partner_id,item.insurer_id)} 
                                        checked={
                                        inputField?.share_insurer_ids
                                            ? inputField.share_insurer_ids.split(',').includes(String(item.insurer_id))
                                            : false
                                        }
                                     disabled={item.is_disable}
                                     />
                                    :   <input id="partner_id" type="radio" className="custom-control-input " name="partner_id" onChange={() => changeHandler(item.id, item.basic_rate_default, item.slug)} checked={+inputField.partner_id === +item.id} />
                                }
                                <label className="custom-control-label"></label>
                            </div>
                        </div>

                        <div className='insure-make-varint'>
                            <div className='insurance-img'>
                                <img src={item.logo} alt='' style={{width:"150px"}} /></div>

                            {
                                !isCountryId && (
                                    <div className='insure-varint-make-detail'>
                                        <span>{props.params.make_name + " " + props.params.model_name + " " + props.params.version_name}</span>
                                        <ul>
                                            <li>{props.params.make_year}</li>
                                            {
                                                props.apptype === APP_TYPE_STANDALONE
                                                    ?
                                                    <>
                                                        <li>{(props.params.transmission) ? props.params.transmission : 'NA'}</li>
                                                        <li>{(props.params.fuel_type) ? props.params.fuel_type : 'NA'}</li>
                                                    </>
                                                    : null
                                            }

                                        </ul>
                                    </div>
                                )
                            }
                            </div>

                            {
                                !isCountryId && (             
                                    <div className='insurance-detail-outer'>
                                        <ul>
                                    
                                            {
                                                (inputField.partner_id === item.id) && (currentInsuranceType === INS_TYPE_COMPREHENSIVE && props.applicationType === WITH_RULE_ENGINE)
                                                    ?
                                                    <li>
                                                    <span> {"Add on Rate(Incremental by "+item.basic_rate_incement+"%)"}</span>

                                                        <button className="ic-remove" onClick={() => handleBtnClick('min', item)}></button>
                                                        <button className="ic-add" style={{ marginLeft: '10px', marginRight: '10px' }} onClick={() => handleBtnClick('add', item)}></button>
                                                    </li>
                                                    : null
                                            }
                                        
                                        {
                                        (currentInsuranceType === INS_TYPE_COMPREHENSIVE && ![VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(props?.params?.vehicle_type)) ?
                                        
                                            <li>
                                                    <span>Act of Nature</span>
                                                    <label>{(actNature?.length>0)?`Included`:`Not Included`}</label>
                                                </li> : null
                                        }
                                        <li>
                                            <span>FMV of Vehicle</span>
                                            <label title={`${HELPER.addCurrencyFormatting(item.total_fmv)}`}>  {HELPER.addCurrencyFormatting(item.total_fmv)}</label>
                                        </li>

                                        {
                                            item.proposed_fmv ?
                                                <li>
                                                    <span>Proposed FMV of Vehicle</span>
                                                    <label title={`${HELPER.addCurrencyFormatting(item.proposed_fmv)}`}>  {HELPER.addCurrencyFormatting(item.proposed_fmv)}</label>
                                                </li>
                                            : null

                                        }

                                        <li>
                                            <span>Own Theft Damage</span>
                                            <label title={`${HELPER.addCurrencyFormatting(item.own_theft_damage)}`}>  {HELPER.addCurrencyFormatting(item.own_theft_damage)}</label>
                                        </li>

                                    

                                        {
                                            item.bi_coverage &&
                                            <li>
                                                <span>BI Coverage Amount</span>
                                                <label title={`${HELPER.addCurrencyFormatting(item.bi_coverage)}`}>  {HELPER.addCurrencyFormatting(item.bi_coverage)}</label>
                                            </li>
                                        }
                                        
                                        {
                                            !(
                                                [VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(props?.params?.vehicle_type) &&
                                                currentInsuranceType !== INS_TYPE_CTPL
                                            ) && 
                                            <li>
                                                <span>BI Premium</span>
                                                <label title={`${HELPER.addCurrencyFormatting(item.bi_amt)}`}>  {HELPER.addCurrencyFormatting(item.bi_amt)}</label>
                                            </li>
                                        }
                                        {
                                            item.hasOwnProperty('pa_amt') ?
                                                <>  
                                                    {
                                                        item.pa_coverage && 
                                                        <li>
                                                            <span>PA Coverage Amount</span>
                                                            <label title={`${HELPER.addCurrencyFormatting(item.pa_coverage)}`}>  {HELPER.addCurrencyFormatting(item.pa_coverage)}</label>
                                                        </li>
                                                    }
                                                    
                                                    {
                                                        item?.total_coverage_amount_pa && 
                                                        <li>
                                                            <span>Total Coverage Amount (PA)</span>
                                                            <label title={`${HELPER.addCurrencyFormatting(item?.total_coverage_amount_pa)}`}>  {HELPER.addCurrencyFormatting(item?.total_coverage_amount_pa)}</label>
                                                        </li>
                                                    }
                                                    <li>
                                                        <span>PA Premium</span>
                                                        <label title={`${HELPER.addCurrencyFormatting(item.pa_amt)}`}>  {HELPER.addCurrencyFormatting(item.pa_amt)}</label>
                                                    </li> 
                                                </>
                                                : null
                                        }
                                        {
                                            item.hasOwnProperty('pd_amt') ?
                                                    <>
                                                        {
                                                            item.pd_coverage &&
                                                            <li>
                                                                <span>PD Coverage Amount</span>
                                                                <label title={`${HELPER.addCurrencyFormatting(item.pd_coverage)}`}>  {HELPER.addCurrencyFormatting(item.pd_coverage)}</label>
                                                            </li>
                                                        }
                                                        <li>
                                                            <span>PD Premium</span>
                                                            <label title={`${HELPER.addCurrencyFormatting(item.pd_amt)}`}>  {HELPER.addCurrencyFormatting(item.pd_amt)}</label>
                                                        </li>
                                                    </>
                                                : null
                                        }
                                        {
                                            (item.hasOwnProperty('tra_amt')) ?
                                                <li>
                                                    <span>TRA Premium</span>
                                                    <label title={`${HELPER.addCurrencyFormatting(item.tra_amt)}`}>  {HELPER.addCurrencyFormatting(item.tra_amt)}</label>
                                                    </li>: null
                                        }
                                        {
                                            (item.hasOwnProperty('rscc_amount')) ?
                                                <li>
                                                    <span>RSCC Premium</span>
                                                    <label title={`${HELPER.addCurrencyFormatting(item.rscc_amount)}`}>  {HELPER.addCurrencyFormatting(item.rscc_amount)}</label>
                                                    </li>: null
                                        }
                                        {
                                            currentInsuranceType === 1 ? 
                                                <li>
                                                    <span>{item.hasOwnProperty('rscc_amount') ? 'BI + PD + PA + RSCC' : 'BI + PD + PA'}</span>
                                                    <label title={`${HELPER.addCurrencyFormatting(item.bi_pd_pa)}`}>  {HELPER.addCurrencyFormatting(item.bi_pd_pa)}</label>
                                                </li> : null
                                        }

                                        <li>
                                            <span>Net Premium</span>
                                            {
                                                showField[item.id] && showField[item.id] === 'net_premium' ?
                                                    <label>
                                                        <fieldset>
                                                            <div className="material">
                                                                <input type="number" name={showField[item.id]} className="form-input input-edit" value={(+inputField.partner_id === +item.id && inputField.net_premium) ? inputField.net_premium : item.net_premium} onChange={(e) => setInputValue(e, item.id)} onBlur={() => setField({})} />
                                                            </div>
                                                        </fieldset>
                                                    </label>
                                                    :
                                                    <label>  {HELPER.addCurrencyFormatting((+inputField.partner_id === +item.id && inputField.net_premium) ? inputField.net_premium : item.net_premium)}
                                                        {+inputField.partner_id === +item.id && currentInsuranceType === INS_TYPE_COMPREHENSIVE && props.applicationType === WITHOUT_RULE_ENGINE &&
                                                            <i className='ic-edit pointer edit-icon' onClick={() => setField({ [item.id]: 'net_premium' })}></i>
                                                        }
                                                    </label>
                                            }
                                        </li>

                                    

                                        
                                
                                        <li>
                                            <span>VAT</span>
                                            <label title={`${HELPER.addCurrencyFormatting(item.vat)}`}>  {HELPER.addCurrencyFormatting(item.vat)}</label>
                                        </li>
                                        <li>
                                            <span>Stamp Duty Govt</span>
                                            <label title={`${HELPER.addCurrencyFormatting(item.stamp_duty)}`}>  {HELPER.addCurrencyFormatting(item.stamp_duty)}</label>
                                        </li>
                                        <li>
                                            <span>Local Govt Taxes</span>
                                            <label title={`${HELPER.addCurrencyFormatting(item.local_govt_taxes)}`}>  {HELPER.addCurrencyFormatting(item.local_govt_taxes)}</label>
                                        </li>
                                        {
                                            item.tariff > 0 &&  
                                            <li>
                                                <span>Tariff</span>
                                                <label title={`${HELPER.addCurrencyFormatting(item.tariff)}`}>  {HELPER.addCurrencyFormatting(item.tariff)}</label>
                                            </li>
                                        }

                                        <li>
                                            <span>Gross Premium</span>
                                            <label title={`${HELPER.addCurrencyFormatting(item.gross_premium)}`}>  {HELPER.addCurrencyFormatting(item.gross_premium)}</label>
                                        </li>
                                        { item?.participation_fees &&
                                        <li>
                                            <span>Participation Fees</span>
                                            <label title={`${HELPER.addCurrencyFormatting(item.participation_fees)}`}>  {HELPER.addCurrencyFormatting(item.participation_fees)}</label>
                                        </li>
                                            }
                                            {
                                                (props.apptype !== APP_TYPE_WITH_UCF) ?
                                                    <li>
                                                        <span>Discount to Customer</span>
                                                        {
                                                            showField[item.id] && showField[item.id] === 'discount' ?
                                                                <label>
                                                                    <fieldset>
                                                                        <div className="material">
                                                                            <input type="number" name={showField[item.id]} className="form-input input-edit" value={(inputField.partner_id === item.id && (inputField.discount || inputField.discount === 0)) ? inputField.discount : 0} onChange={(e) => setInputValue(e, item.id)} onBlur={() => {
                                                                                setField({})
                                                                                if(inputField.discount !== 0 && inputField.discount < 10) {
                                                                                    toast.error("Please enter a valid discount amount")
                                                                                    setInputField((prev: any) =>  ({...prev, discount: item.discount}))
                                                                                }
                                                                            }} />
                                                                        </div>
                                                                    </fieldset>
                                                                </label>
                                                                :
                                                                <label>  {HELPER.addCurrencyFormatting((inputField.partner_id === item.id && (inputField.discount || inputField.discount === 0)) ? inputField.discount : 0)}
                                                                    {
                                                                        inputField.partner_id === item.id &&
                                                                        <i className='ic-edit pointer edit-icon' onClick={() => setField({ [item.id]: 'discount' })}></i>
                                                                    }

                                                                </label>
                                                        }
                                                    </li> : null
                                            }

                                            {
                                                (item.hasOwnProperty('referrer_mark_up')) ?
                                                    <li>
                                                        <span>Referrer Mark Up</span>
                                                        {
                                                            showField[item.id] && showField[item.id] === 'referrer_mark_up' ?
                                                                <label>
                                                                    <fieldset>
                                                                        <div className="material">
                                                                            <input type="number" name={showField[item.id]} className="form-input input-edit" value={(inputField.partner_id === item.id && inputField.referrer_mark_up) ? inputField.referrer_mark_up : item.referrer_mark_up} onChange={(e) => setInputValue(e, item.id)} onBlur={() => setField({})} />
                                                                        </div>
                                                                    </fieldset>
                                                                </label>
                                                                :
                                                                <label>  {HELPER.addCurrencyFormatting((inputField.partner_id === item.id && inputField.referrer_mark_up) ? inputField.referrer_mark_up : item.referrer_mark_up)}
                                                                    {
                                                                        inputField.partner_id === item.id &&
                                                                        <i className='ic-edit pointer edit-icon' onClick={() => setField({ [item.id]: 'referrer_mark_up' })}></i>
                                                                    }

                                                                </label>
                                                        }
                                                    </li> : null
                                            }
                                            {
                                                props.apptype === APP_TYPE_WITH_UCF
                                                    ?
                                                    <li>
                                                        <span>Final Premium</span>
                                                        <label title={`${HELPER.addCurrencyFormatting(item.final_premium)}`}>  {HELPER.addCurrencyFormatting(item.final_premium)}</label>
                                                    </li>
                                                    : null
                                            }
                                            {
                                                (props.apptype !== APP_TYPE_WITH_UCF && item.total_premium)
                                                    ?
                                                    <li>
                                                    <span>Total Premium</span>
                                                    <label title={`${HELPER.addCurrencyFormatting(item.total_premium)}`}>
                                                        {inputField?.discount ? HELPER.addCurrencyFormatting(((item.gross_premium + item?.referrer_mark_up || 0) - inputField.discount).toFixed(2)) : HELPER.addCurrencyFormatting((item.final_premium))}
                                                    </label>
                                                    </li>
                                                    : null
                                            }
                                        </ul>
                                    </div>
                                )
                            }
                            {
                                isCountryId && (
                                    <div className='insurance-detail-outer'>
                                        <ul key={`ul-${index}`}>
                                
                                           {/* <li>
                                                <span>{translations?.CREATE_APPLICATION?.INS_TYPE}</span>
                                                <label>{item?.insurance_type_name || '--'}</label>
                                            </li>  */}

                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.USAGE_TYPE}</span>
                                                <label>{props.masterData?.vehicle_usage?.find((el: any) => el.value === props?.params?.vehicle_usage)?.label || '--'}</label>
                                            </li> 

                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.ESTIMATED_TSI}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.car_fmv || 0)}</label>
                                            </li> 

                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.PRICE_OF_ACC}</span>
                                                <label>{HELPER.addCurrencyFormatting(props.params?.acc_price || 0)}</label>
                                            </li> 

                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.CAR_PRICE}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.total_fmv || 0)}</label>
                                            </li> 

                                             {/* <li>
                                                <span>{translations?.CREATE_APPLICATION?.BASIC_PREMIUM}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.basic_premium_amount || 0)}</label>
                                            </li> 


                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.ADD_ONS_PREMIUM}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.total_addon_amount || 0)}</label>
                                            </li> 


                                            <li>
                                                <span>{translations?.CREATE_APPLICATION?.DETAIL_OF_ADDONS}</span>
                                                {
                                                   
                                                    item?.addon_list?.length > 0 && (
                                                    <div className="addonlist">
                                                        <span className="" title={''}>
                                                        {item?.addon_list[0]?.name}
                                                        {item?.addon_list?.length > 1 && " ..."}
                                                        {
                                                            item?.addon_list?.length > 1 && (
                                                                <i
                                                                    className="ic-info-icon1 cursor-pointer text-gray-500 hover:text-gray-700" style={{marginLeft:"5px",marginTop:"2px"}}
                                                                    onClick={() => {
                                                                       handleTooltip(`addon${index}`,'add');
                                                                    }}
                                                                    data-tooltip-id={`addon${index}`}
                                                                ></i>
                                                            )
                                                        }
                                                        </span>
                                                        {
                                                            tooltip[`addon${index}`]  && item?.addon_list?.length > 1 && 
                                                            <div className='tooltip-outer'>
                                                                <TooltipLite
                                                                    isOpen={tooltip[`addon${index}`]}
                                                                    className=" react-tooltip-lite"
                                                                    id={`addon${index}`}
                                                                    place="bottom"
                                                                    clickable={true}
                                                                    render={() =>
                                                                        <div className="tooltip-data">
                                                                            <span className="controlled-example_close-button" onClick={() => {  handleTooltip(`addon${index}`,'close'); }}><i className="ic-clearclose"></i></span>

                                                                          {item?.addon_list?.map((addon: any, index: number) => (
                                                                                <div key={index} className="addon-item p-sm-t">
                                                                                {addon?.name}
                                                                                </div>
                                                                            ))}
                                                                     
                                                                        </div>
                                                                    }
                
                                                                />
                                                            </div>
                                                        }

                                                    </div>
                                                    )
    
                                                }
                                            </li>  */}
                                            <AddOnsDetailsBreakdown data={item?.addons_by_tenure} />

                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.TOTAL_PREMIUM}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.total_premium_amount || 0)}</label>
                                            </li> 

                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.DISCOUNT}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.customer_discount || 0)}</label>
                                            </li> 

                                            <li>
                                                <span>{translations?.CREATE_APPLICATION?.ADMIN_FEE}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.admin_fee || 0)}</label>
                                            </li> 


                                             <li>
                                                <span>{translations?.CREATE_APPLICATION?.TOTAL_PAID}</span>
                                                <label>{HELPER.addCurrencyFormatting(item?.final_premium || 0)}</label>
                                            </li> 

                                        </ul>
                                    </div>
                                )
                            }


                        

                    </div>)
                }) : 
                <div className='financer-quote-data p-t-70'>
                    <div style={{marginTop:"50px"}}>
                        {translations.commonMsg?.['No data found']}
                    </div>
                </div>
            } 
        </div>
    )
}

export default QuotesListID
